export const GENERAL_SECTION_SPACING = [10, 10, "112px"];
export const MAIN_VIEW_WIDTH = ["auto", "670px", "604px", "752px"];

export const HIDE_CONTENT_CHART_TEST_ID = "hide-content-chart";
export const HIDE_CONTENT_PORTFOLIO_DISTRIBUTION_TEST_ID = "hide-content-portfolio-distribution";
export const HIDE_CONTENT_PORTFOLIO_TABLE_TEST_ID = "hide-content-portfolio-table";
